export default __webpack_public_path__ + "static/media/avery_dimension.1aca73bb.png";